export class Badget<T> {
  id: string;
  name: string;
  data: T;
  isSelected: boolean;
}
